import type { FC } from 'react'
import { Alert, Snackbar } from '@mui/material'
import type { ToastSeverity } from './icons'
import { TOAST_ICON_MAPPING } from './icons'
import { alertSx, snackbarSx } from './styles'

interface ToastNotificationProps {
  readonly open: boolean
  readonly message: string
  readonly severity: ToastSeverity
  readonly onClose: () => void
  readonly autoHideDuration?: number
}

const ToastNotification: FC<ToastNotificationProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 4000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={snackbarSx}
    >
      <Alert onClose={onClose} severity={severity} icon={TOAST_ICON_MAPPING[severity]} sx={alertSx}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export type { ToastNotificationProps }
export { ToastNotification }
